<template>
  <div class="page">
    <el-dialog title="成员列表" :visible.sync="memberParams.dialogTableVisible">
      <div class="box_row">
        <el-input placeholder="成员姓名／联系电话">
          <template slot="append">搜索</template>
        </el-input>
        <div>
          <el-button>批量删除</el-button>
          <el-button type="primary">新增成员</el-button>
        </div>
      </div>
      <el-table :data="gridData" header-row-class-name="table-header">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="date" label="创建时间"></el-table-column>
        <el-table-column property="date" label="成员姓名"></el-table-column>
        <el-table-column property="date" label="联系电话"></el-table-column>
        <el-table-column property="name" label="联系邮箱"></el-table-column>
        <el-table-column property="address" label="所属角色"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button class="table-btn" @click.native.prevent="editMember(scope.row)" type="text" size="small">
              修改信息
            </el-button>
            <el-button
              class="table-btn detele"
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >
              删除成员
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination class="footer" :params="params"></Pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  inject: {
    editMember: 'change',
  },
  props: {
    memberParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      gridData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区',
        },
      ],
      params: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      }, //翻页
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
/deep/.el-dialog {
  border-radius: 5px !important;
}
.box_row {
  justify-content: space-between;
  font-family: Helvetica Neue, Helvetica Neue-Regular;
  font-weight: 400;
  .el-input {
    width: 314px;
  }
  /deep/.el-input-group__append {
    background: #4359b7;
    color: #fff;
    border: 1px solid #4359b7;
  }
  .el-button {
    padding: 12px 17px;
  }
  .el-button:first-child {
    margin-right: 20px;
    border-color: #4359b7;
    color: #4359b7;
  }
}
/deep/.el-dialog__header {
  padding-bottom: 0;
}
.el-table {
  border: 1px solid #dddfe3;
  margin-top: 20px;
  .detele {
    margin: 0;
    color: #43aab7;
    padding-top: 10px;
  }
  .table-btn {
    padding: 0;
  }
}
/deep/.table-header .cell {
  color: #999;
  font-weight: 400;
}
.footer {
  text-align: right;
  padding: 10px 36px;
  border: 1px solid #dddfe3;
  border-top: none;
}
</style>
